import { IPagination } from "../../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../../http.hook";
import { IPayoutMethod } from "./approve-payout.admin.http";

export interface IGetPayoutPendingListResponse {
  payoutMethods: IPayoutMethod[];
  pagination: IPagination;
}

export function useGetPendingPayoutAdminHttp() {
  return useGetHttp<IGetPayoutPendingListResponse>({
    path: "/admin/kyc/creator/payout",
  });
}
